export type CurrencyInputValue = number | null;
